export default __webpack_public_path__ + "static/media/terrain.545c56f0.svg";